import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { InjectIconDirective, SafeHtmlPipe } from '@boels/helpers';
import { CmsComponentData, UspComponentModel } from '@boels/models';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@jsverse/transloco';

@Component({
  imports: [
    CommonModule,
    FontAwesomeModule,
    InjectIconDirective,
    SafeHtmlPipe,
    TranslocoModule,
  ],
  selector: 'boels-usp',
  host: { ngSkipHydration: 'true' },
  templateUrl: './usp.component.html',
  styleUrls: ['./usp.component.scss'],
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: ['addToCart'],
    },
  ],
})
export class UspComponent {
  @Input() componentData: CmsComponentData<UspComponentModel>;
  @Input() direction: string;

  getDirection(direction: string | undefined): string {
    if (this.direction) {
      return this.direction;
    }

    if (direction) {
      return direction.toLowerCase();
    }

    return 'horizontal';
  }

  isHorizontal(): boolean {
    return this.direction === 'horizontal';
  }
}
